var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.141 512.141"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2c3e50",
    d: "M185.45 432.622h141.241v52.966H185.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.071 370.829v30.455c1.261 20.815-14.506 38.749-35.31 40.165H35.381C14.576 440.032-1.19 422.098.071 401.284v-30.455h512z",
    fill: "#556080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512.071 40.236v330.593h-512V40.236C-1.19 19.421 14.576 1.487 35.381.071H476.76c20.805 1.416 36.571 19.35 35.311 40.165z",
    fill: "#3d324c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.795 81.373v109.639a3.434 3.434 0 01-3.531 3.266H65.395a3.363 3.363 0 01-3.531-3.178V81.373l50.229-45.021a4.265 4.265 0 015.473 0l50.229 45.021z",
    fill: "#f3d55b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.829 229.588v52.966l-44.138 26.483-1.236.794a52.141 52.141 0 01-7.592-27.277c.001-29.253 23.714-52.966 52.966-52.966z",
    fill: "#f0c419"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.795 282.553a52.471 52.471 0 01-15.537 37.429l-37.429-37.429v-52.966c29.252.001 52.966 23.714 52.966 52.966z",
    fill: "#ff5364"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.258 319.982a52.889 52.889 0 01-82.803-10.151l1.236-.794 44.138-26.483 37.429 37.428z",
    fill: "#24ae5f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M291.381 44.209h17.655a8.828 8.828 0 018.828 8.828v105.931h-35.31V53.036a8.826 8.826 0 018.827-8.827z",
    fill: "#f0c419"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M359.618 88.346h22.422a6.444 6.444 0 016.444 6.444v64.177h-35.31V94.791a6.445 6.445 0 016.444-6.445z",
    fill: "#ff5364"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M428.888 114.829h25.114a5.094 5.094 0 015.094 5.094v39.044h-35.302v-39.044a5.095 5.095 0 015.094-5.094z",
    fill: "#24ae5f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.243 309.036a8.829 8.829 0 01-6.241-15.069l31.656-31.656c10.482-10.002 26.974-10.002 37.455 0l10.337 10.346a8.828 8.828 0 0012.482 0l36.829-36.829c10.479-10.001 26.968-10.001 37.447 0l10.346 10.346a8.828 8.828 0 0012.482 0l31.656-31.647a8.828 8.828 0 0112.483 12.483l-31.656 31.656c-10.354 10.309-27.093 10.309-37.447 0l-10.346-10.355a9.013 9.013 0 00-12.482 0l-36.829 36.829c-10.342 10.338-27.105 10.338-37.447 0l-10.346-10.346a9.013 9.013 0 00-12.482 0l-31.656 31.656a8.827 8.827 0 01-6.241 2.586z",
    fill: "#ff5364"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.312 476.76h229.517c14.626 0 26.483 11.857 26.483 26.483v8.828H114.829v-8.828c0-14.626 11.857-26.483 26.483-26.483z",
    fill: "#556080"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff5364"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.45 106.002a8.829 8.829 0 01-5.888-2.251l-64.733-57.944-64.733 57.944c-3.638 3.197-9.173 2.866-12.404-.743s-2.951-9.146.628-12.41l67.902-60.787a13.011 13.011 0 0117.055-.132l68.061 60.91a8.829 8.829 0 01-5.888 15.413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.864 90.2a8.828 8.828 0 01-8.828-8.828V57.45a8.828 8.828 0 0117.656 0v23.923a8.829 8.829 0 01-8.828 8.827z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#b49aca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.933 167.795H264.898c-14.626 0-26.483-11.857-26.483-26.483V35.381a8.828 8.828 0 0117.656 0v105.931a8.828 8.828 0 008.828 8.828h203.034a8.828 8.828 0 010 17.655zM467.933 344.346H264.898c-14.626 0-26.483-11.857-26.483-26.483v-105.93a8.828 8.828 0 0117.656 0v105.931a8.828 8.828 0 008.828 8.828h203.034a8.828 8.828 0 010 17.654z"
  }))));
}

export default __webpack_public_path__ + "bc5f1a03f515f7116df01528c613e1e2.svg";
export { SvgHome as ReactComponent };